<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
</ngx-spinner>

<div dir="{{languageDir}}">
<div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
</div>

<div class="content">
    <div class="header-title">
        <h1 class="main-title">{{langObj ? langObj?.Supervisor : ('Supervisor' | translate)}}</h1>
    </div>
    <form name="HeaderForm" [formGroup]="HeaderForm" class="w-70">
        <div class="w-100 headerForm d-flex">
          
            <div class="inputField w-20">
                <nz-date-picker class="date-picker" readonly [nzShowTime]="false" nzFormat="dd-MMM-yyyy"
                    [(ngModel)]="dateFilter.From" formControlName="fromDate" (ngModelChange)="getFilterData()">
                </nz-date-picker>
                <span class="floating-text">{{langObj ? langObj?.From : ('From' | translate)}}</span>
                <div *ngIf="!dateFilter.From" class="error-message">{{langObj ? langObj?.Fromdateisrequired : ('Fromdateisrequired' | translate)}}</div>
            </div>

            <div class="inputField w-20">
                <nz-date-picker class="date-picker" readonly [nzShowTime]="false" nzFormat="dd-MMM-yyyy"
                    [(ngModel)]="dateFilter.To" formControlName="toDate" (ngModelChange)="getFilterData()">
                </nz-date-picker>
                <span class="floating-text">{{langObj ? langObj?.To : ('To' | translate)}}</span>
                <div *ngIf="!dateFilter.To" class="error-message">{{langObj ? langObj?.Todateisrequired : ('Todateisrequired' | translate)}}</div>
                <div *ngIf="dateFilter.From > dateFilter.To && dateFilter.To" class="error-message">{{langObj ? langObj?.TodatemustbegreaterthanFromdate : ('TodatemustbegreaterthanFromdate' | translate)}}</div>
            </div>

            <mat-form-field appearance="fill" class="w-20">
                <mat-label>{{langObj ? langObj?.Search : ('Search' | translate)}}</mat-label>
                <input matInput type="text" (keyup)="onFilterChanged($event.target)">
            </mat-form-field>
        </div>
    </form>

    <div class="import_export">
        <button *ngIf="isAccess | permissionChecker" class="export" (click)="ExportTOExcel()">{{langObj ? langObj?.Export : ('Export' | translate)}}</button>
    </div>

</div>

<div class="d-flex justify-content-center" style="margin-top: 50px;">
  <div class="score-cards-wrapper d-flex" style="gap: 12px;">
    <mat-card class="open" style="padding: 10px; text-align: center; background-color: #f8f9fa;">
      <b color="warn">{{langObj ? langObj?.OpenedTasks : ('OpenedTasks' | translate)}} : {{openCount}}</b>
    </mat-card>  
    <mat-card class="closed" style="padding: 10px; text-align: center; background-color: #e9ecef;">
      <b>{{langObj ? langObj?.ClosedTasks : ('ClosedTasks' | translate)}} : {{closedCount}}</b>
    </mat-card>  
    <mat-card class="completed" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
      <b>{{langObj ? langObj?.CompletedTasks : ('CompletedTasks' | translate)}} : {{completedCount}}</b>
    </mat-card>
    <mat-card class="inprogress" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
      <b>{{langObj ? langObj?.InprogressTasks : ('InprogressTasks' | translate)}} : {{inProgressCount}}</b>
    </mat-card>     
    <!-- <mat-card class="delayed" style="padding: 10px; text-align: center; background-color: #f1f3f5;">
      <b>{{langObj ? langObj?.DelayedTasks : ('DelayedTasks' | translate)}} : {{delayedCount}}</b>
    </mat-card> -->
  </div>
</div>

<div style="margin-top: 20px;">
    <ag-grid-angular style="width: 100%; height: 30vw;" class="ag-theme-alpine" [rowData]="rowData"
        [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (cellClicked)="cellClicked($event)"
        [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10"
        [frameworkComponents]="frameworkComponents">
    </ag-grid-angular>
</div>
</div>